module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/barcode-read.svg?e7927bab75e31fbb15e105c66f8059e5";